(function () {
  "use strict";

  const PHONE_FORMAT_DELAY = 50;
  const PHONE_FORMAT_INIT_DELAY = 1000;
  const EMBED_INIT_ATTEMPTS = 10;
  const EMBED_INIT_DELAY = 100;

  function applyRtlStyles(root) {
    if (root.querySelector("style[data-rtl-fix]")) {
      return;
    }

    const style = document.createElement("style");
    style.dataset.rtlFix = "true";
    style.textContent = `
    form[data-testid="form"] input:not([type="checkbox"]):not([type="radio"]):not([type="hidden"]),
    form[data-testid="form"] textarea,
    form[data-testid="form"] select {
      text-align: right;
    }

    form[data-testid="form"] input:not([type="checkbox"]):not([type="radio"]):not([type="hidden"]) + label[id^="label-"],
    form[data-testid="form"] textarea + label[id^="label-"],
    form[data-testid="form"] select + label[id^="label-"] {
      right: 15px;
      left: auto;
      text-align: right;
      transform-origin: right top;
    }

    form[data-testid="form"] [role="listbox"],
    form[data-testid="form"] [role="option"],
    form[data-testid="form"] ul,
    form[data-testid="form"] li,
    form[data-testid="form"] option {
      text-align: right;
    }
  `;

    root.prepend(style);
  }

  function formatPhoneValueForFocus(phoneInput) {
    phoneInput.value = phoneInput.value.replace(/^(\+\d+)\s*$/u, "$1 ");
  }

  function formatPhoneValueForBlur(phoneInput) {
    phoneInput.value = phoneInput.value.replace(/^(\+\d+)\s+$/u, "$1");
  }

  function schedulePhoneFormatting(
    phoneInput,
    formatter,
    delay = PHONE_FORMAT_DELAY,
  ) {
    setTimeout(() => {
      formatter(phoneInput);
    }, delay);
  }

  function bindPhoneInputFix(root) {
    const phoneInput = root.querySelector('input[type="tel"]');

    if (!phoneInput || phoneInput.dataset.rtlPhoneFixApplied === "true") {
      return;
    }

    phoneInput.dataset.rtlPhoneFixApplied = "true";

    const valueDescriptor = Object.getOwnPropertyDescriptor(
      HTMLInputElement.prototype,
      "value",
    );

    if (!valueDescriptor) {
      return;
    }

    let skipNormalization = false;

    Object.defineProperty(phoneInput, "value", {
      get() {
        return valueDescriptor.get.call(this);
      },
      set(nextValue) {
        valueDescriptor.set.call(this, nextValue);

        if (skipNormalization) {
          return;
        }

        const valueAfterSet = valueDescriptor.get.call(this);
        const normalizedValue = valueAfterSet.replace(/^(\+\d+)\s+$/u, "$1");

        if (normalizedValue !== valueAfterSet) {
          valueDescriptor.set.call(this, normalizedValue);
        }
      },
      configurable: true,
    });

    schedulePhoneFormatting(
      phoneInput,
      formatPhoneValueForBlur,
      PHONE_FORMAT_INIT_DELAY,
    );

    phoneInput.addEventListener("focus", () => {
      skipNormalization = true;

      schedulePhoneFormatting(phoneInput, formatPhoneValueForFocus);

      setTimeout(() => {
        skipNormalization = false;
      }, PHONE_FORMAT_DELAY + 10);
    });

    phoneInput.addEventListener("blur", () => {
      schedulePhoneFormatting(phoneInput, formatPhoneValueForBlur);
    });
  }

  function observeEmbedRoot(embed, root) {
    if (embed.dataset.rtlRootObserverAttached === "true") {
      return;
    }

    embed.dataset.rtlRootObserverAttached = "true";

    let scheduled = false;

    const observer = new MutationObserver(() => {
      if (scheduled) {
        return;
      }

      scheduled = true;

      requestAnimationFrame(() => {
        scheduled = false;
        bindPhoneInputFix(root);
      });
    });

    observer.observe(root, {
      childList: true,
      subtree: true,
    });
  }

  function initEmbed(embed, attempts = EMBED_INIT_ATTEMPTS) {
    if (embed.dataset.rtlEmbedInitialized === "true") {
      return;
    }

    const root = embed.shadowRoot;

    if (!root) {
      if (attempts > 0) {
        setTimeout(() => {
          initEmbed(embed, attempts - 1);
        }, EMBED_INIT_DELAY);
      }

      return;
    }

    embed.dataset.rtlEmbedInitialized = "true";

    applyRtlStyles(root);
    bindPhoneInputFix(root);
    observeEmbedRoot(embed, root);
  }

  function processNode(node) {
    if (!(node instanceof HTMLElement)) {
      return;
    }

    if (node.matches("shopify-forms-embed")) {
      initEmbed(node);
      return;
    }

    node.querySelectorAll("shopify-forms-embed").forEach(initEmbed);
  }

  function applyRtlToExistingEmbeds() {
    document.querySelectorAll("shopify-forms-embed").forEach(initEmbed);
  }

  function startObserver() {
    const target = document.body;

    if (!target) {
      return;
    }

    const pending = new Set();
    let scheduled = false;

    const flush = () => {
      scheduled = false;

      for (const node of pending) {
        processNode(node);
      }

      pending.clear();
    };

    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        for (const node of mutation.addedNodes) {
          pending.add(node);
        }
      }

      if (scheduled) {
        return;
      }

      scheduled = true;
      requestAnimationFrame(flush);
    });

    observer.observe(target, {
      childList: true,
      subtree: true,
    });
  }

  function initShopifyFormsRtl() {
    applyRtlToExistingEmbeds();
    startObserver();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => {
      initShopifyFormsRtl();
    });
  } else {
    initShopifyFormsRtl();
  }
})();
